import Vue from 'vue'
import VeeValidate from "vee-validate";
import validationMessagesEn from "vee-validate/dist/locale/en";
import validationMessagesEs from "vee-validate/dist/locale/es";
import validationMessagesDe from "vee-validate/dist/locale/de";
import i18n from "../i18n";
Vue.use(VeeValidate, {
  i18nRootKey: "validations",
  inject: true,
  fieldsBagName: "veeFields",
  i18n,
  dictionary: {
    en: validationMessagesEn,
    es: validationMessagesEs,
    de: validationMessagesDe
  }
});